import { render, staticRenderFns } from "./UserEditSalary.vue?vue&type=template&id=1c5ccd4d&"
import script from "./UserEditSalary.vue?vue&type=script&lang=js&"
export * from "./UserEditSalary.vue?vue&type=script&lang=js&"
import style0 from "./UserEditSalary.vue?vue&type=style&index=0&id=1c5ccd4d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports